import { loading } from 'State/actions';
import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

import { createToast, toastType } from '../../../common/ToastHelper';

export const getSpecialMessageReportAction = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loadingReportAction(true));
    await MPWWebApi.postGenericInsertUpdate('reports/specialmessage', data)
      .then(response => {
        dispatch({
          type: types.GET_SPECIAL_MESSAGE_REPORT,
          payload: response,
        });
        dispatch(loadingReportAction(false));
        if (response.data.Data === null || response.data.Data.length === 0) {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
      })
      .catch(error => {
        dispatch({
          type: types.GET_SPECIAL_MESSAGE_REPORT_ERROR,
          payload: error.response,
        });
        dispatch(loadingReportAction(false));
        if (error.response.data.Errors[0].Title === null) {
          createToast(toastType.error, 'Error', 'Unable to view report', true);
        } else {
          createToast(
            toastType.error,
            error.response.data.Errors[0].Title,
            error.response.data.Errors[0].Message,
            true
          );
        }
      });
  };
};

export const getSpecialMessageReportExcel = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.SPECIAL_MESSAGE_REPORT_LOAD, true));

      const dataPresent = await MPWWebApi.postDownloadFile(
        'reports/SpecialMessage',
        'SpecialMessageReport',
        data,
        FileDownloadTypes.ExcelOpenXML
      );
      if (!dataPresent) {
        createToast(toastType.info, 'Results', 'No data found!', true);
      }
} catch (ex) {
      dispatch({
        type: types.GET_SPECIAL_MESSAGE_REPORT_ERROR,
        payload: ex.response.data.Errors,
      });
    } finally {
      dispatch(loading(types.SPECIAL_MESSAGE_REPORT_LOAD, false));
    }
  };
};

export const loadingReportAction = status => {
  return {
    type: types.SPECIAL_MESSAGE_REPORT_LOAD,
    payload: status,
  };
};

export const clearReportDataAction = () => {
  return {
    type: types.CLEAR_REPORT_DATA,
  };
};



// WEBPACK FOOTER //
// ./src/pages/specialmessage/state/actions.js